import JSONAPISerializer from "@ember-data/serializer/json-api";
import { service } from "@ember/service";
import type Store from "ember-data/store";
import type SemeiaSessionService from "parog-web/services/session";
import { serializeToDateString } from "parog-web/utils/time";

export type PatientSerializedPayload = {
  data: {
    attributes: Record<string, string | null>;
    relationships: Record<string, string>;
  };
};

export default class extends JSONAPISerializer {
  @service declare session: SemeiaSessionService;
  @service declare store: Store;

  override attrs = {
    uuid: { serialize: false },
    passwordChangedAt: { serialize: false }
  };

  override serialize(snapshot, options) {
    const json = super.serialize(snapshot, options) as PatientSerializedPayload;

    delete json.data.attributes["uses-the-app"];
    delete json.data.attributes["access-word"];
    delete json.data.attributes["patient-consent"];
    delete json.data.attributes["has-ongoing-rch-survey-procedure"];
    delete json.data.attributes["has-ongoing-crohn-survey-procedure"];
    delete json.data.attributes["follow-up-reason"];
    delete json.data.attributes["enrollment-status"];
    delete json.data.attributes["mrc-stage"];
    delete json.data.attributes["dialysis-type"];
    delete json.data.attributes["has-preferred-unit-cache-pending"];

    if (!snapshot.record.isNew) {
      delete json.data.attributes["imported-follow-up-reason"];
    }

    if (snapshot.record.isNew && snapshot.record.healthCentreCohorts) {
      json.data.attributes["health-centre-cohorts-attributes"] =
        snapshot.record.healthCentreCohorts.map(hcc => ({
          "health-centre-id": hcc.healthCentre.id,
          "referent-medic-id": hcc.referentMedic?.id,
          role: hcc.role,
          "ipp-number": hcc.ippNumber
        }));
    }

    const birthday = snapshot.attr("birthday");
    if (birthday) {
      json.data.attributes.birthday = serializeToDateString(birthday);
    }
    return json;
  }
}
